export default class BurgerMenu {
    constructor(burgerSelector, menuSelector, options = {}) {
        this.burger = document.querySelector(burgerSelector);
        this.menu = document.querySelector(menuSelector);
        this.options = {
            closeOnOutsideClick: true,
            lockBodyScroll: true,
            ...options,
        };

        if (!this.burger || !this.menu) {
            console.error('BurgerMenu: Burger or Menu element not found');
            return;
        }

        this.init();
    }

    init() {
        this.burger.addEventListener('click', () => this.toggleMenu());

        if (this.options.closeOnOutsideClick) {
            document.addEventListener('click', (event) => this.closeMenuOnOutsideClick(event));
        }
    }

    toggleMenu() {
        const isActive = this.burger.classList.toggle('active');
        this.menu.classList.toggle('active');

        if (this.options.lockBodyScroll) {
            document.body.style.overflow = isActive ? 'hidden' : '';
        }

        const eventName = isActive ? 'burger-open' : 'burger-close';
        this.menu.dispatchEvent(new CustomEvent(eventName, { detail: { burger: this.burger, menu: this.menu } }));
    }

    closeMenuOnOutsideClick(event) {
        if (!this.menu.contains(event.target) && !this.burger.contains(event.target)) {
            this.burger.classList.remove('active');
            this.menu.classList.remove('active');

            if (this.options.lockBodyScroll) {
                document.body.style.overflow = '';
            }

            this.menu.dispatchEvent(new CustomEvent('burger-close', { detail: { burger: this.burger, menu: this.menu } }));
        }
    }
}
